import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTriangleExclamation = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 13,
	viewBox: "0 0 16 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14.8359 11.1523L8.98438 1.19922C8.54688 0.433594 7.42578 0.433594 6.96094 1.19922L1.13672 11.1523C0.699219 11.918 1.24609 12.875 2.14844 12.875H13.8242C14.7266 12.875 15.2734 11.918 14.8359 11.1523ZM7.34375 4.34375C7.34375 3.98828 7.61719 3.6875 8 3.6875C8.35547 3.6875 8.65625 3.98828 8.65625 4.34375V7.84375C8.65625 8.22656 8.35547 8.5 8 8.5C7.61719 8.5 7.34375 8.22656 7.34375 7.84375V4.34375ZM8 11.125C7.50781 11.125 7.125 10.7422 7.125 10.2773C7.125 9.8125 7.50781 9.42969 8 9.42969C8.46484 9.42969 8.84766 9.8125 8.84766 10.2773C8.84766 10.7422 8.46484 11.125 8 11.125Z",
		fill: "#FF1744"
	})]
});
const ForwardRef = forwardRef(SvgTriangleExclamation);
export { ForwardRef as ReactComponent };
